import { render, staticRenderFns } from "./selectProducts.vue?vue&type=template&id=de36d8a0&scoped=true"
import script from "./selectProducts.vue?vue&type=script&lang=ts"
export * from "./selectProducts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de36d8a0",
  null
  
)

export default component.exports